









export default {
  name: 'PurchasesHidePurchaseRequestController',
  computed: {
    showHiddenUrl() {
      // Важно сбрасывать страницу, т.к. есть пагинация и меняется набор итемов,
      // можно выйти за пределы пагинации, в данном случае show_hidden работает как фильтр
      return {
        ...this.$route,
        query: { ...this.$route.query, show_hidden: 1, page: 1 },
      };
    },
    showAllUrl() {
      return {
        ...this.$route,
        query: { ...this.$route.query, show_hidden: undefined, page: 1 },
      };
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/purchases/components/PurchasesHidePurchaseRequestController.vue